
import { Vue, Options } from "vue-class-component";
import Nav from "../../components/nav/Nav.vue";
import Prize from "../../components/lottery/Prize.vue";
import { Http, ResponseData } from "../../net/Http";
import { Urls } from "../../net/Urls";
import {
  LotteryModel,
  CurWinner,
  LuckyCodes
} from "../../model/lottery/LotteryModel";

@Options({
  components: {
    Nav,
    Prize
  }
})
export default class LuckyCodesList extends Vue {
  private dataModel: LotteryModel | null = null;
  private datas: LuckyCodes[] = [];
  private curWinner: CurWinner | null = null;

  mounted() {
    this.getLotteryData();
    this.curWinnerData();
    this.luckyCodes();
  }
  getLotteryData() {
    Http.get<LotteryModel>(Urls.lottery_curPhase).then(
      (res: LotteryModel) => {
        this.dataModel = res;
      },
      (err: ResponseData) => {
        console.log(Urls.lottery_curPhase, err.message);
        // openToast(err.message);
      }
    );
  }
  curWinnerData() {
    Http.get<CurWinner>(Urls.lottery_curWinner).then(
      (res: CurWinner) => {
        this.curWinner = res;
      },
      (err: ResponseData) => {
        console.log(Urls.lottery_curWinner, err.message);
        // openToast(err.message);
      }
    );
  }
  luckyCodes() {
    Http.get<LuckyCodes[]>(Urls.lottery_luckyCodes).then(
      (res: LuckyCodes[]) => {
        this.datas = res;
      },
      (err: ResponseData) => {
        console.log(Urls.lottery_luckyCodes, err.message);
        // openToast(err.message);
      }
    );
  }
  isStatusText(index: number) {
    if (this.datas[index].status == 0) {
      return "未开奖";
    } else if (this.datas[index].status == 1) {
      return "中奖了";
    } else if (this.datas[index].status == -1) {
      return "未中奖";
    }
    return "";
  }
}
